import LightingObjectsIcon from './component'

export default LightingObjectsIcon
